import React, { useState } from "react";
import "./Home.css";
import Header from "../../components/HomePage/HeaderHome/HeaderHome";
import Footer from "../../components/Common/Footer/Footer";
import IntroSectionHome from "../../components/HomePage/IntroSectionHome/IntroSectionHome";
import IntroSectionHome2 from "../../components/HomePage/IntroSectionHome/IntroSectionHome2";
import Newsletter from "../../components/Common/Newsletter/Newsletter";
import Navbar from "../../components/Common/Navbar/Navbar";
import ParallaxComponent from "../../components/Common/ParallaxBackground/ParallaxComponent";
import ContactLinkSection from "../../components/Common/ContactLinkSection/ContactLinkSection";
import ParallaxIMG0 from './../../assets/images/itmonkeys-cyber-img-p0.png';
import ParallaxIMG1 from './../../assets/images/itmonkeys-cyber-img-p1.png';
import ParallaxIMG2 from './../../assets/images/itmonkeys-cyber-img-p2.png';
import ExpertiseSection from '../../components/HomePage/ExpertiseSectionHome/ExpertiseSectionHome';
import introSectionData14 from '../../components/Common/IntroSectionBottom/introSectionData14';
import useSectionRefs from '../../hooks/useSectionRefs';
import SEO from '../../components/Common/SEO/SEO';
import { AboutUS } from '../../components/HomePage/AboutUS/AboutUS';
import { StickyScrollRevealDemo } from '../../components/HomePage/ChooseITM/ChooseITM';
import { seoConfig } from '../../data/seoConfig';
import { contactLinkData } from '../../data/contactLinkData';
import BlogCards from "../../components/Common/BlogCards/BlogCards";
import { GlobeDemo } from "../../components/HomePage/GlobeSection/GlobeSection";
import IntroSectionAiHome from "../../components/HomePage/IntroSectionAiHome/IntroSectionAiHome";
import DatabaseWithRestApi from "../../components/Common/Graphics/database-with-rest-api";
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import HomeSlider from "../../components/HomePage/HomeSlider/HomeSlider";
import { Gallery4Demo } from "../../components/Common/ProjectsCards/ProjectCards";
import CertificationsAzure from "../../components/HomePage/CertificationsAzure/CertificationsAzure";

const Home: React.FC = () => {
  const sectionRefs = useSectionRefs();

  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleOpenContactModal = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <>
      <SEO 
        title={seoConfig.home.title}
        description={seoConfig.home.description}
        path="/"
      />
      
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header />
        </div>
      </section>
      
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionHome />
      </section>

      <section id="services" className="section light" ref={sectionRefs.services}>
        <IntroSectionHome2 academyData={introSectionData14} />
      </section>

      <section id="expertise" className="section dark" ref={sectionRefs.expertise}>
        <HomeSlider />
      </section>

      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
        <ContactLinkSection pageKey="home" />
        <Footer />
      </section>
    </>
  );
};

export default Home;
